/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
  <div class="paginacion" :class="getGeneral" v-show="showPagination">
    <div class="anterior" :class="getClasesAnterior" @click="cambiarPagina(1)">
      <p>Anterior</p>
    </div>
    <div class="pagina">
      <p class="actual">{{ paginaActual }}</p>
      <p class="ultima">de {{ total }}</p>
    </div>
    <div class="siguiente" :class="getClasesSiguiente" @click="cambiarPagina(2)">
      <p>Siguiente</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Paginacion',
  components: {},
  props: {
    total: {
      type: Number,
      required: false,
      default: 1,
    },
    paginaActualEntrada: {
      type: Number,
      default: 1,
    },
    puntoVenta: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      paginaActual: this.paginaActualEntrada,
    }
  },
  emits: ['changePagina'],
  methods: {
    cambiarPagina(tipo) {
      let nuevaPagina = this.paginaActual;
      if (tipo === 1 && this.paginaActual > 1) {
        nuevaPagina -= 1;
      } else if (tipo === 2 && this.paginaActual < this.total) { 
        nuevaPagina += 1;
      }
      if (nuevaPagina !== this.paginaActual) {
        this.paginaActual = nuevaPagina; 
        this.$emit('changePagina', nuevaPagina); 
      }
    },
  },
  computed: {
    getClasesAnterior() {
      return {
        disabled: this.paginaActual <= 1,
      }
    },
    getClasesSiguiente() {
      return {
        disabled: this.paginaActual >= this.total,
      };
    },
    showPagination() {
      return this.total > 1; 
    },
    getGeneral() {
      return {
        'paginador-general': this.puntoVenta,
      }
    },
  },
  watch: {
    paginaActualEntrada: {
      immediate: true,
      handler(newVal) {
        this.paginaActual = newVal;
      }
    },
    total() {
        this.paginaActual = 1;
        this.$emit('changePagina', 1);
    },
  },
}
</script>

<style scoped>
.paginacion {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  gap: 40px;
  user-select: none;
}

.paginacion .anterior,
.paginacion .siguiente {
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 0.3s;
  color: #5F5F5F;
  font-weight: bold;
  font-size: 14px;
}

.paginacion .anterior.disabled,
.paginacion .siguiente.disabled {
  cursor: no-drop;
  opacity: 0.25;
  transition: 0.3s;
}

.paginacion .pagina {
  display: flex;
  align-items: center;
  padding: 0px 7px;
  font-weight: 700;
  font-size: 14px;
}

.paginacion .pagina .actual {
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 4px;
  margin-right: 4px;
  font-size: 16px;
}

.paginacion .pagina .ultima {
  font-weight: normal;
  opacity: 0.56;
}

@media (max-width: 1279px) {}

@media (max-width: 767px) {
  .paginacion {
    margin-bottom: 15px;
  }

  .paginador-general {
    margin-bottom: unset;
  }
}
</style>